import jQuery from "jquery";
import ExceptionHandling from "shared/logging/exception_handling";

function updateValidationErrorState(element, error, title) {
  if (error) {
    element.addClass('error_background');
    element.attr('title', title);
  } else {
    element.removeClass('error_background');
    element.attr('title', '');
  }
}

function validateEmail(element, email, mode) {
  if (mode === "focus") {
    updateValidationErrorState(element, false);
  } else {
    var trimmedEmail = jQuery.trim(email);
    var emailValid = trimmedEmail.match(/^[a-z0-9!#~%&'=./$*+-?^_`{}|]+@([-a-z0-9]+\.)+[a-z]{2,}$/i);
    updateValidationErrorState(element, (trimmedEmail !== "" && !emailValid), 'Email does not appear valid');
  }
}

export default function validateEmailOn(inputSelector) {
  var input = jQuery(inputSelector);
  if (input.length === 0) {
    ExceptionHandling.logWarning("validate_email_on - No input found for selector: " + inputSelector);
    return;
  }

  input.blur(function() { validateEmail(jQuery(this).parent(), jQuery(this).val(), 'blur'); });
  input.focus(function() { validateEmail(jQuery(this).parent(), jQuery(this).val(), 'focus'); });
}
